import { isEmpty } from 'lodash';
import type { WidgetInsightsResponseDto } from '../../redux/config/widgetApi';
import { InsightItem } from '../common/insight-item.component';

interface AiInsightFieldsProps {
  insightItem: WidgetInsightsResponseDto | undefined;
}

export const AiInsightFields = ({ insightItem }: AiInsightFieldsProps) => {
  if (isEmpty(insightItem)) {
    return null;
  }

  const {
    data_analysis = '',
    potential_causes = '',
    recommendations = '',
    future_trends = '',
    missing_values_analysis = '',
    summary = '',
  } = insightItem || {};

  const insightFields = [
    ['Data Analysis', data_analysis],
    ['Potential Causes', potential_causes],
    ['Recommendations', recommendations],
    ['Future Trends', future_trends],
    ['Missing Values Analysis', missing_values_analysis],
    ['Summary', summary],
  ];

  return (
    <>
      {insightFields.map(([label, fieldValue]) => (
        <InsightItem key={label} label={label} value={fieldValue} />
      ))}
    </>
  );
};
